import { render, staticRenderFns } from "./teachteam.vue?vue&type=template&id=596a9a55&scoped=true&"
import script from "./teachteam.vue?vue&type=script&lang=js&"
export * from "./teachteam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a9a55",
  null
  
)

export default component.exports